
<template>
  <div class='layout' id="detail" :show ="show">
    <span class="closeIcon" @click="onClose()"><img src="../../assets/img/closeIcon.png" alt=""></span>
    <div class="parent">
      <div id="sPrev" class="pagenav" @click="getPrev()">
        <img src="../../assets/img/prev-icon.png" />
        
      </div>
      <div id="sNext" class="pagenav" @click="getNext()">
        <img src="../../assets/img/next-icon.png" />
        
      </div>
      <div class="swiper-container">
        <!-- <swiper
              ref="listSwiper"
              class="swiper-wrapper swiper-no-swiping"
              :options="swiperOption"
            >
              <swiper-slide
                class="swiper-slide"
                :class="{'slide-active':index===activeIdx}"
                v-for="(item, index) in list"
                :key="index"
              > -->
        <div class="top-title"><span>{{name}}</span></div>
        <div class="top-swiper">
          <islide :id="id"></islide>
        </div>
        <div class="bottom-text">
         <span>年代：{{time}}</span> 
         <span v-if="save">完残：{{save}}</span> 
         <span v-if="source">来源：{{source}}</span> 
         <!--  <div class="content_bg">
            <p class="content">{{activeItem.content}}</p>
             <span @click="audioPlay()" :class="[audio?'audio on':'audio off']" v-show="activeItem.audio"></span>
          </div> -->
         
        </div>
        <!-- <img @click="slideto(index)" class="logo" :src="item"/> -->
        <!-- </swiper-slide>
            </swiper> -->


      </div>
    </div>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  /* import browser from "@/utils/browser.js"; */
  
  /* import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
  import "swiper/css/swiper.css"; */
  import islide from "@/components/islide"
  /* import slide from '@/components/slide' */
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
      
      /*     Swiper,
          SwiperSlide, */
      islide
    },
    /* directives: {
        swiper: directive,
      }, */
    data() {
      //这里存放数据
      return {
        show:false,
        list: [],
        curId: '',
        activeIdx: '',
        activeItem: {},
        audio: false
      };
    },
    //监听属性 类似于data概念
    computed: {
      /* swiperOption() {
      return {
        autoplay:false,
        navigation: {
            nextEl: "#sNext", //前进按钮的css选择器或HTML元素。
            prevEl: "#sPrev", //后退按钮的css选择器或HTML元素。

},
        }
     
    }, */
    },
    //监控data中的数据变化
    watch: {

    },
    //方法集合
    methods: {
      onClose() {
         setTimeout(() => {
        this.show = false;
        document.body.removeChild(this.$el);
        this.$destroy();
      }, 0);
      },
      getItem(index) {
        this.$store.commit('changeAudio', false);
        console.log(this.$store.audio)
        this.activeIdx = index;
        this.list.forEach((item, i) => {
          if (this.activeIdx == i) {
            this.id = item.id;
            this.time = item.time;
            this.source = item.source;
            this.save = item.save;
            this.name = item.name;
          }
        })


      },
      getPrev() {
        if (this.activeIdx > 0) {
          this.getItem(this.activeIdx - 1)
        }
      },
      getNext() {
        console.log(this.total,this.activeIdx)
        if (this.activeIdx < this.total - 1) { 
          console.log(this.activeIdx)         
          this.getItem(this.activeIdx + 1)
        }
      },
      audioPlay() {
        let audio = document.getElementById("antique_bgm");
        if (this.audio) {
          audio.pause();
          this.audio = false
        } else {
          this.audio = true;
          audio.play();
        }
      },
      async getList() {
        let res = await this.$http({
          method: "get",
          url: `data.json`
        });
        this.list = res.list;
        this.list.forEach((item, i) => {
          if (item.id == this.id) {
            this.activeIdx = i;
            this.activeItem = item;
           
          }
        })
        this.total = res.list.length;
      },
      slide(name) {
        if (name === 'slideNext') {
          if (this.activeIdx < this.list.length - 1) {
            this.activeIdx += 1
          } else {
            return
          }
        } else {
          this.activeIdx = this.activeIdx > 0 ? this.activeIdx - 1 : this.activeIdx
        }

        this.swiper[name]()
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getList();
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  :root {
    --swiper-theme-color: #d20000;
  }

  .layout {
     /* width:78.6vw;
     height:78vh; */
     width:100%;
     height:100%;
    position: fixed;
    top:5%;
    top:0;
    left:0;
    right:0;
    margin:auto;
    background:rgba(0,0,0,0.3);
    background:#a1a1a1;
     border:1px solid #a61f24;
     /*  border-radius:2vw; */
    z-index:100;
    .closeIcon {
      position:absolute;
      top:20px;
      right:20px;
    }
    .parent {
      position: relative;
      width: 74%;
      margin: 0 auto;
      padding-top: 2vw;

      .pagenav {
        width: 64px;
        height: 64px;
        position: absolute;
        cursor:pointer;
      }

      #sPrev {
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }

      #sNext {
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }

      .swiper-container {
        margin: 0 auto;
        width: 45.6vw;
        /* display: flex;
        justify-content: space-between;
        align-items: flex-start; */
        .top-title {
          text-align:center;
          margin-bottom:1vw;
          span {
            display:inline-block;
          height:2.55vw;
          line-height:2.55vw;
          
          color:#e6e5e5;
          font-size:1.61vw;
          text-align:center;
          
          &:before {
            content:'';
            display:inline-block;
            width:1.35vw;
            height:100%;
            background:url(../../assets/img/detail-icon1.png)center no-repeat;
            vertical-align: top;
            margin-right:1vw;
          }
          &:after {
            content:'';
            display:inline-block;
            width:1.35vw;
            height:100%;
            background:url(../../assets/img/detail-icon2.png)center no-repeat;
            vertical-align: top;
            margin-left:1vw;
          }
          }
        }
        .top-swiper {
          width: 45.6vw;
          height:30.7vw;
          max-width: 876px;
          
          border: 2px solid #810101;
          overflow:hidden;
        }

        .bottom-text {
          position: relative;
          width: 45.6vw;
          
          margin-top:1vw;
          background:rgba(255,255,255,0.2);
          /* border: 2px solid #810101; */
          /* background: url(../../assets/images/text_bg.png)center/100% no-repeat; */
         /*  padding: 0 25px; */
         padding:1vw 2vw;
          span{
            font-size:1vw;
            color:#e6e5e5;
            margin-right:1vw;
          }
          .content_bg {
            position:relative;
            width:14.1vw;
            height:15vw;
            display: flex;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .content {
              text-indent: 2em;
              font-size: 15px;
              color: #434343;
              padding: 0 1.3vw;
            }

            .audio {
              position: absolute;
              bottom: 10px;
              right: 30px;
              display: block;
              width: 25px;
              height: 25px;

              &.on {
                background: url('../../assets/images/audio_on.png')center/100% no-repeat;
              }

              &.off {
                background: url('../../assets/images/audio_off.png')center/100% no-repeat;
              }
            }
          }
        }
      }
    }


  }
</style>